import { __decorate } from "tslib";
import { ChameleonElementMixin } from '../../common/mixin';
import { attr } from '@microsoft/fast-element';
import { Anchor } from '@microsoft/fast-foundation';
export class BaseNavigationRailLinkComponent extends ChameleonElementMixin(Anchor) {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.appearance = 'navrailitem';
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.querySelector('[slot="end"]')?.assignedNodes().length <= 0) {
            this.removeAttribute('data-has-end-slot');
        }
        else {
            this.setAttribute('data-has-end-slot', '');
        }
    }
}
__decorate([
    attr({ mode: 'boolean' })
], BaseNavigationRailLinkComponent.prototype, "selected", void 0);
__decorate([
    attr({ mode: 'boolean' })
], BaseNavigationRailLinkComponent.prototype, "disabled", void 0);
__decorate([
    attr
], BaseNavigationRailLinkComponent.prototype, "appearance", void 0);
